import { CircularProgress, Grid } from '@mui/material';
import React from 'react';

export default function LoadingIndicator({ size }: { size?: number }) {
    return (
        <Grid container justifyContent="center">
            <CircularProgress size={size} />
        </Grid>
    );
}
